import Form, {CompareRule, GroupItem, Label, RequiredRule, SimpleItem, StringLengthRule} from "devextreme-react/form";
import {useRef} from "react";
import {useSnackbar} from "notistack";

const dataPassword = {
    password: '',
    compare: '',
};

const passwordOptions = {
    mode: 'password'
};

function NewPassword() {

    const dxForm = useRef(null);
    const {enqueueSnackbar} = useSnackbar();

    const passwordComparison = () => {
        return dataPassword.password;
    };

    const onSubmitNewPassword = () => {

    }

    return (
        <>
            <form action="" onSubmit={onSubmitNewPassword}>
                <Form
                    ref={dxForm}
                    formData={dataPassword}
                    readOnly={false}
                    showColonAfterLabel={true}
                    validationGroup="customerData"
                >
                    <GroupItem caption="Contraseña nueva" colCount={1}>
                        <SimpleItem dataField="password" label={{text: 'Contraseña', location: 'top'}}
                                    editorOptions={passwordOptions}>
                            <RequiredRule message="Ingrese una contraseña"/>
                            <StringLengthRule min={6} max={10}
                                              message="La contraseña debe tener al menos 6 caracteres y maximo 10"/>
                        </SimpleItem>
                        <SimpleItem dataField='compare' editorType="dxTextBox" editorOptions={passwordOptions}>
                            <Label text="Confirmar contraseña" location={'top'}/>
                            <RequiredRule message="Debe confirmar la contraseña"/>
                            <CompareRule
                                message="Las contraseñas no coinciden"
                                comparisonTarget={passwordComparison}
                            />
                        </SimpleItem>
                    </GroupItem>
                </Form>
            </form>
        </>
    )

}

export default NewPassword;